var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_vm._t("default",[_c('b-card',{staticClass:"card-custom gutter-b mb-5",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-4 p-sm-8"},[_vm._t("item-list")],2)],1),_vm._t("modal")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }